// Tastenkürzel für Tooltips und aria-keyshortcuts. Mod ist auf Apple-Geräten
// die Befehlstaste, sonst Strg, wie in ProseMirror-Keymaps.

const APPLE_SYMBOLS = { Mod: '⌘', Alt: '⌥', Shift: '⇧' }
const ARIA_NAMES = { Alt: 'Alt', Shift: 'Shift' }

// userAgentData.platform ist in Chromium "macOS", navigator.platform "MacIntel"
export const isApplePlatform = (nav = globalThis.navigator) =>
  /mac|iphone|ipad/i.test(nav?.userAgentData?.platform || nav?.platform || '')

/**
 * @param {string[]} keys z. B. ['Mod', 'Alt', '1']
 * @param {object} [options]
 * @param {boolean} [options.apple]
 * @param {{ ctrl: string, alt: string, shift: string }} [options.labels] übersetzte Tastennamen
 * @returns {string} '⌘⌥1' auf Apple-Geräten, sonst z. B. 'Strg+Alt+1'
 */
export const formatShortcut = (
  keys,
  { apple = isApplePlatform(), labels = {} } = {}
) => {
  if (apple) {
    return keys.map((key) => APPLE_SYMBOLS[key] || key.toUpperCase()).join('')
  }

  const names = {
    Mod: labels.ctrl || 'Ctrl',
    Alt: labels.alt || 'Alt',
    Shift: labels.shift || 'Shift'
  }
  return keys.map((key) => names[key] || key.toUpperCase()).join('+')
}

/**
 * @param {string[]} keys
 * @param {object} [options]
 * @param {boolean} [options.apple]
 * @returns {string} Wert für aria-keyshortcuts, z. B. 'Meta+B' oder 'Control+B'
 */
export const toAriaKeyshortcuts = (keys, { apple = isApplePlatform() } = {}) =>
  keys
    .map((key) =>
      key === 'Mod'
        ? apple
          ? 'Meta'
          : 'Control'
        : ARIA_NAMES[key] || key.toUpperCase()
    )
    .join('+')
